import { z } from 'zod'

/** Who fills in the application: the learner (`self`) or a parent applying for a child. */
export const RESPONDENTS = ['self', 'parent'] as const

export type Respondent = (typeof RESPONDENTS)[number]

export const respondentSchema = z.enum(RESPONDENTS)

export const DEFAULT_RESPONDENT: Respondent = 'self'
